export default "__VITE_ASSET__Bv$FYdmL__"